import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=2923e76a&scoped=true&lang=html"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923e76a",
  null
  
)

export default component.exports